<template>
	<div class="sidebar">
		<el-menu
			class="sidebar-el-menu"
			:default-active="onRoutes"
			:collapse="collapse"
			:background-color="projectName == 'WGQ' ? '#324157' : ''"
			:text-color="projectName == 'WGQ' ? '#bfcbd9' : ''"
			:active-text-color="projectName == 'WGQ' ? '#20a0ff' : ''"
			unique-opened
			router
			@open="foropen"
			@close="forclose"
			@select="forselect"
		>
			<template v-for="item in items">
				<template v-if="item.children">
					<el-submenu :index="item.index" :key="item.index">
						<template slot="title">
							<div v-if="projectName == 'WGQ'">
								<i :class="item.icon"></i>
								<span slot="title">{{ item.label }}</span>
							</div>
							<div v-else>
								<i
									:class="
										item.children.map(gtem => gtem.index).includes(choosepath) ? (item.iconClick ? item.iconClick + ' ei-iconclick ' : item.icon) : item.icon
									"
								></i>
								<span slot="title" :style="item.children.map(gtem => gtem.index).includes(choosepath) ? 'color: #0065B1;font-weight:bold' : ''">
									{{ item.label }}
								</span>
								<i
									v-if="!collapse"
									:class="choosesub == item.index && closesub != item.index ? 'el-icon-caret-bottom meauicon' : 'el-icon-caret-top meauicon'"
									:style="item.children.map(gtem => gtem.index).includes(choosepath) ? 'color: #0065B1;font-size: 12px;' : 'font-size: 12px;'"
								></i>
							</div>
						</template>
						<template v-for="subItem in item.children">
							<el-submenu v-if="subItem.children3" :index="subItem.index" :key="subItem.index">
								<template slot="title">
									<i :class="subItem.icon"></i>
									<span slot="title">{{ subItem.label }}</span>
								</template>
								<el-menu-item v-for="(threeItem, i) in subItem.children" :key="i" :index="threeItem.index">{{ threeItem.title }}</el-menu-item>
							</el-submenu>
							<el-menu-item v-else :index="subItem.index" :key="subItem.index">
								<i :class="subItem.icon"></i>
								<span slot="title">{{ subItem.label }}</span>
							</el-menu-item>
						</template>
					</el-submenu>
				</template>
				<template v-else>
					<el-menu-item :index="item.index" :key="item.index">
						<i :class="item.checked && notemptyandnull(item.iconClick) && choosepath == item.index ? item.iconClick + ' ei-iconclick ' : item.icon"></i>
						<span slot="title">{{ item.label }}</span>
					</el-menu-item>
				</template>
			</template>
		</el-menu>
		<img src="../../assets/img/siderimg.png" class="sidebarimg" v-if="projectName != 'WGQ'" @click="forchangeMeau" />
	</div>
</template>

<script>
import bus from '../common/bus';
import configHttp from '../../../configHttp.js';
export default {
	data() {
		return {
			collapse: false,
			items: [],
			routes: {},
			projectName: '',
			choosepath: ''
		};
	},
	computed: {
		onRoutes(e) {
			return this.$route.path.replace('/', '');
		}
	},
	watch: {
		// 监听路由
		$route(val, from) {
			// 调用获取路由数组方法
			this.choosepath = val.path.replace('/', '');
		}
	},
	methods: {
		forselect(e) {
			this.choosepath = e;
		},
		foropen(e) {
			this.closesub = '';
			this.choosesub = e;
		},
		forclose(e) {
			this.closesub = e;
		},
		forchangeMeau() {
			this.collapse = !this.collapse;
			bus.$emit('collapse-content', this.collapse);
		}
	},
	created() {
		this.choosepath = this.$route.path.replace('/', '');
		var routearr = localStorage.getItem('routearr');
		var userFunction = JSON.parse(localStorage.getItem('userFunction'));
		this.projectName = configHttp.projectName;
		if ((routearr != null) & (routearr != '')) {
			/* 	this.items = this.meautree(userFunction); */
			this.items = userFunction;
			let Fillinandissuepositiveinvoice = '';
			userFunction.forEach(item => {
				if (this.notemptyandnull(item.children)) {
					item.children.forEach(gtem => {
						if (gtem.index == 'Fillinandissuepositiveinvoice') {
							localStorage.setItem('Fillinandissuepositiveinvoice', JSON.stringify(gtem.buttomroute));
						}
						if (gtem.index == 'FillingPositiveInvoice') {
							localStorage.setItem('FillingPositiveInvoice', JSON.stringify(gtem.buttomroute));
						}
					});
				}
			});
		}
		/* console.log(this.meautree(routearr)) */
		// 通过 Event Bus 进行组件间通信，来折叠侧边栏
		bus.$on('collapse', msg => {
			this.collapse = msg;
			bus.$emit('collapse-content', msg);
		});
	}
};
</script>

<style scoped lang="less">
.el-icon-icon50 {
	background: url('../../assets/img/icon50.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon50:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon1 {
	background: url('../../assets/img/icon1.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon1:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon2 {
	background: url('../../assets/img/icon2.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon2:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon3 {
	background: url('../../assets/img/icon3.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon3:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon4 {
	background: url('../../assets/img/icon4.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon4:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon5 {
	background: url('../../assets/img/icon5.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon5:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon6 {
	background: url('../../assets/img/icon6.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon6:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon7 {
	background: url('../../assets/img/icon7.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon7:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon8 {
	background: url('../../assets/img/icon8.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon8:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon9 {
	background: url('../../assets/img/icon9.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon9:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon10 {
	background: url('../../assets/img/icon10.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon10:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon11 {
	background: url('../../assets/img/icon11.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon11:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon12 {
	background: url('../../assets/img/icon12.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon12:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon13 {
	background: url('../../assets/img/icon13.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon13:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon14 {
	background: url('../../assets/img/icon14.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon14:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon15 {
	background: url('../../assets/img/icon15.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon15:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon16 {
	background: url('../../assets/img/icon16.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon16:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon17 {
	background: url('../../assets/img/icon17.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon17:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon18 {
	background: url('../../assets/img/icon18.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon18:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon19 {
	background: url('../../assets/img/icon19.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon19:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon20 {
	background: url('../../assets/img/icon20.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon20:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon21 {
	background: url('../../assets/img/icon21.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon21:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon22 {
	background: url('../../assets/img/icon22.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon22:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon23 {
	background: url('../../assets/img/icon23.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon23:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon24 {
	background: url('../../assets/img/icon24.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon24:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon25 {
	background: url('../../assets/img/icon25.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon25:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon26 {
	background: url('../../assets/img/icon26.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon26:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon27 {
	background: url('../../assets/img/icon27.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon27:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon28 {
	background: url('../../assets/img/icon28.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon28:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon29 {
	background: url('../../assets/img/icon29.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon29:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon30 {
	background: url('../../assets/img/icon30.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon30:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon31 {
	background: url('../../assets/img/icon31.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon31:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon32 {
	background: url('../../assets/img/icon32.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon32:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon33 {
	background: url('../../assets/img/icon33.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon33:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon34 {
	background: url('../../assets/img/icon34.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon34:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon35 {
	background: url('../../assets/img/icon35.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon35:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon36 {
	background: url('../../assets/img/icon36.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon36:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon37 {
	background: url('../../assets/img/icon37.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon37:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon38 {
	background: url('../../assets/img/icon38.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon38:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-icon39 {
	background: url('../../assets/img/icon39.png') center no-repeat !important;
	background-size: cover !important;
}
.el-icon-icon39:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-menu--popup {
	min-width: 100px;
}
.sidebar {
	display: flex;
	position: absolute;
	left: 0;
	align-items: center;
	top: 50px;
	bottom: 0;
	overflow-x: hidden;
}
::-webkit-scrollbar-thumb {
	/*滚动条里面小方块*/
	border-radius: 10px;
	background-color: #d8d8d8;
}

::-webkit-scrollbar-track {
	/*滚动条里面轨道*/
	border-radius: 10px;
}

::-webkit-scrollbar {
	width: 0px !important;
	height: 0px !important;
}
.sidebarimg {
	margin-left: -3px;
	width: 0px;
	transition: width 0.8s ease-in-out;
}
.sidebar::-webkit-scrollbar {
	width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
	width: 200px;
}

.sidebar > ul {
	height: 100%;
	overflow-y: auto;
}
.el-menu {
	border-right: 0px;
	box-sizing: border-box;
	padding: 0px 16px 0px 16px;
}
.el-submenu .el-menu-item {
	min-width: auto;
	padding-left: 30px !important;
	// margin: 0px 20px 0px 20px;
}

/deep/.el-submenu__title {
	padding-left: 0px !important;
}
/deep/.el-menu-item * {
	padding-left: 0px !important;
}
/deep/.el-menu-item {
	padding-left: 0px !important;
}
/deep/.el-submenu__icon-arrow {
	display: none;
}

.ei-iconclick1 {
	background: url('../../assets/img/newicon1on.svg') center no-repeat !important;
	background-size: cover !important;
	font-size: 24px !important;
	margin: 0px 5px 0px 0px !important;
}
.ei-iconclick1:before {
	content: '替';
	font-weight: 500;
	font-size: 24px;
	visibility: hidden;
}

.ei-iconclick2 {
	background: url('../../assets/img/newicon2on.svg') center no-repeat !important;
	background-size: cover !important;
	font-size: 24px !important;
	margin: 0px 5px 0px 0px !important;
}

.ei-iconclick2:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}

.ei-iconclick3 {
	background: url('../../assets/img/newicon3on.svg') center no-repeat !important;
	background-size: cover !important;
	font-size: 24px !important;
	margin: 0px 5px 0px 0px !important;
}

.ei-iconclick3:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}

.ei-iconclick4 {
	background: url('../../assets/img/newicon4on.svg') center no-repeat !important;
	background-size: cover !important;
	font-size: 24px !important;
	margin: 0px 5px 0px 0px !important;
}

.ei-iconclick4:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}

.ei-iconclick5 {
	background: url('../../assets/img/newicon5on.svg') center no-repeat !important;
	background-size: cover !important;
	font-size: 24px !important;
	margin: 0px 5px 0px 0px !important;
}

.ei-iconclick5:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}

.ei-iconclick6 {
	background: url('../../assets/img/newicon6on.svg') center no-repeat !important;
	background-size: cover !important;
	font-size: 24px !important;
	margin: 0px 5px 0px 0px !important;
}

.ei-iconclick6:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}

.el-icon-newicon1 {
	background: url('../../assets/img/newicon1.svg') center no-repeat !important;
	background-size: cover !important;
}

.el-icon-newicon1:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-newicon2 {
	background: url('../../assets/img/newicon2.svg') center no-repeat !important;
	background-size: cover !important;
}

.el-icon-newicon2:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}

.el-icon-newicon3 {
	background: url('../../assets/img/newicon3.svg') center no-repeat !important;
	background-size: cover !important;
}

.el-icon-newicon3:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}

.el-icon-newicon4 {
	background: url('../../assets/img/newicon4.svg') center no-repeat !important;
	background-size: cover !important;
}

.el-icon-newicon4:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}

.el-icon-newicon5 {
	background: url('../../assets/img/newicon5.svg') center no-repeat !important;
	background-size: cover !important;
}

.el-icon-newicon5:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}

.el-icon-newicon6 {
	background: url('../../assets/img/newicon6.svg') center no-repeat !important;
	background-size: cover !important;
}

.el-icon-newicon6:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}

.el-icon-newicon7 {
	background: url('../../assets/img/newicon7.svg') center no-repeat !important;
	background-size: cover !important;
}

.el-icon-newicon7:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}

.ei-iconclick7 {
	background: url('../../assets/img/newicon7on.svg') center no-repeat !important;
	background-size: cover !important;
	font-size: 24px !important;
	margin: 0px 5px 0px 0px !important;
}

.ei-iconclick7:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}

.el-icon-newicon8 {
	background: url('../../assets/img/newicon8.svg') center no-repeat !important;
	background-size: cover !important;
}

.el-icon-newicon8:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}

.ei-iconclick8 {
	background: url('../../assets/img/newicon8on.svg') center no-repeat !important;
	background-size: cover !important;
	font-size: 24px !important;
	margin: 0px 5px 0px 0px !important;
}

.ei-iconclick8:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.el-icon-newicon9 {
	background: url('../../assets/img/newicon9.svg') center no-repeat !important;
	background-size: cover !important;
}

.el-icon-newicon9:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}

.ei-iconclick9 {
	background: url('../../assets/img/newicon9on.svg') center no-repeat !important;
	background-size: cover !important;
	font-size: 24px !important;
	margin: 0px 5px 0px 0px !important;
}

.ei-iconclick9:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}

.el-icon-newicon10 {
	background: url('../../assets/img/newicon10.svg') center no-repeat !important;
	background-size: cover !important;
}

.el-icon-newicon10:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}

.ei-iconclick10 {
	background: url('../../assets/img/newicon10on.svg') center no-repeat !important;
	background-size: cover !important;
	font-size: 24px !important;
	margin: 0px 5px 0px 0px !important;
}

.ei-iconclick10:before {
	content: '替';
	font-size: 24px;
	visibility: hidden;
}
.ei-iconclick,
.ei-iconclick:before {
	display: inline-block;
	width: 24px;
	height: 24px;
}
.sidebar:hover {
	ul {
		box-shadow: 2px 0px 4px 0px #e9e9e9;
		z-index: 100;
	}
	.sidebarimg {
		width: 22px;
		cursor: pointer;
		height: 98px;
		box-shadow: 2px 0px 4px 0px #e9e9e9;
		z-index: 100;
	}
}
/deep/.el-menu-item.is-active {
	color: #0065b1 !important;
	font-weight: 600;
}
/deep/.el-menu-item:hover {
	background-color: #e5effd;
	border-radius: 4px;
}
</style>
